<template>
    <div class="content">
        <div class="panel">
            <div class="panel1">
                <div class="panel-header">
                    <span @click="toView(2)">更多</span>
                </div>
                <div class="panel-split"></div>
                <div class="panel-body">
                    <div class="inner-border">
                        <p class="bold">白色污染对策</p>
                        <p class="indent">总结国内外防治“白色污染”的实践经验，结合目前“白色污染”现状及其管理工作中存在的问题，我国防治“白色污染”应遵循“以宣传教育为先导，以强化管理为核心，以回收利用为主要手段，以替代产品为补充措施”的原则。</p>
                        <p class="indent">防治“白色污染”，首先要解决“视觉污染”问题，使市容、景观有明显改善。这主要是靠宣传教育，引导市民形成良好的生活习惯；同时要依法强化管理…………</p>
                    </div>
                </div>
            </div>
            <div class="panel-text"></div>
            <div class="panel2">
                <div class="panel-header">
                    <span @click="toView(3)">更多</span>
                </div>
                <div class="panel-split"></div>
                <div class="panel-body">
                    <div class="inner-border">
                        <p class="bold">白色污染的防治</p>
                        <p class="indent">1985年，美国人均消费塑料包装物就已达23.4公斤，日本为20.1公斤。九十年代，发达国家人均消费塑料包装物的数量更多（从消费量来看，似乎发达国家的“白色污染”应该很严重，实则不然。究其原因，一是发达国家很早就严抓市容管理，基本消除了“视觉污染”，二是发达国家生活垃圾无害化处置率较高）</p>
                        <p class="indent">现在已建立起了一套严密的分类回收系统，大部分废旧…………</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="text">
            <img src="../../../assets/artist-text/so-good-no-pollution.png" />
        </div>
        <div class="text-xsl">
            <img  @click="toView(4)" src="../../../assets/artist-text/xiansuling.png" />
        </div>

    </div>
</template>

<script>
    export default {
        name: "PreventAndDoMainView",
        data() {
            return {
                index: 1
            }
        },
        methods: {
            toView(value) {
                this.$emit("onIndexChanged", value)
            }
        }
    }
</script>

<style lang="scss" scoped>

    .content {
        height: 40%;
        width: 90%;
        margin-left: 5%;
        .panel {
            margin-top: 20%;
            .panel1 {
                width: 35%;
                float: left;
            }
            .panel-split {
                width: 100%;
                height: 5px;
                background: #cddbf4;
            }
            .panel-text {
                width: 34px;
                margin-left: 20px;
                margin-right: 20px;
                height: 270px;
                margin-top: 16px;
                float: left;
                background: url("../../../assets/artist-text/provent-wp-from-mime.png") no-repeat;
            }
            .panel2 {
                width: 35%;
                float: left;
            }
            .panel1, .panel2 {
                $panelWidth : 200px;
                $panelHeight : 260px;
                height: $panelHeight;
                width: $panelWidth;
                .panel-header {
                    width: 100%;
                    height: 24px;
                    background: #f3f3f3;
                    border-bottom: 1px solid #d5d8d9;
                    text-align: right;
                    span {
                        font-size: 12px;
                        color: #5c5c5c;
                        margin-right: 5px;
                        line-height: 24px;
                        cursor: pointer;
                    }
                }
                .panel-body {
                    background: #cddbf4;
                    margin-top: -2px;
                    height: $panelHeight - 24;
                    .inner-border {

                        width: $panelWidth  - 10;
                        height: $panelHeight - 24 - 4 - 3;
                        margin-left: 4px;
                        margin-top: 0px;
                        border: 1px solid #fff;
                        font-size: 12px;
                        p {
                            text-indent: 13px;
                            margin: 0;
                            text-overflow: ellipsis;
                        }
                    }
                }
            }
        }
        .text {
            img {
                margin-top: 26px;
                height: 28px;
                margin-left: 50px;
            }
        }
        .text-xsl {
            cursor: pointer;
            img {
                margin-top: 26px;
                height: 28px;
            }
        }

    }
</style>